import React from 'react';

const LoadingSmall: React.FC = () => {
  return (
    <div className="loading-small-container">
      <wa-animation name="flip" easing="ease-in-out" duration={1000} play>
        <img src="/images/lgcy-loading.png" alt="Loading..." className="loading-spinner" />
      </wa-animation>
    </div>
  );
}

export default LoadingSmall;
